module.exports = __webpack_public_path__ + "static/media/refund_success.3958b0b8.svg";